import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { BankAccountForm } from 'src/Components/Forms/BankAccount/BankAccountForm';
import { FRENCH_BANKS, OTHER_BANK_VALUE } from 'src/Constants/frenchBanks';
import { useCreateBankAccountForm } from 'src/Hooks/Forms/useCreateBankAccountForm';
import { useUpdateBankAccount } from 'src/Hooks/Mutations/useUpdateBankAccount';
import useFetchBankAccount from 'src/Hooks/Queries/useFetchBankAccount';

import { Props } from './BankAccountEditionFormWrapper.types';

const BankAccountEditionFormWrapper = ({ bankAccountId, onCancel, onCreate }: Props) => {
  const { data: bankAccount } = useFetchBankAccount(bankAccountId);
  const { form } = useCreateBankAccountForm();
  const { mutate } = useUpdateBankAccount({ onSuccess: () => onCreate() });

  const { t } = useTranslation();

  useEffect(() => {
    if (bankAccount) {
      const matchedBank = FRENCH_BANKS.find(bank => bank.name === bankAccount.bankName);
      form.setValues({
        name: bankAccount.name,
        bankSelection: matchedBank
          ? matchedBank.name
          : bankAccount.bankName
            ? OTHER_BANK_VALUE
            : '',
        bankName: bankAccount.bankName ?? '',
        bankDetail: bankAccount.bankDetail ?? '',
        holderName: bankAccount.holderName ?? '',
        iban: bankAccount.iban ?? '',
        bic: bankAccount.bic ?? '',
      });
    }
  }, [bankAccount]);

  return (
    <BankAccountForm
      onCancel={onCancel}
      form={form}
      onSubmit={form.onSubmit(values => {
        mutate({ bankAccountId, updateData: values });
      })}
      submitButtonLabel={t('bankAccounts.editExpense', 'Modifier')}
    />
  );
};

export default BankAccountEditionFormWrapper;
